import React, { useState, useEffect, useRef, useMemo } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import ActivityLogs from './ActivityLogs';
import { Button, IconButton, Pagination, Paper, Skeleton, Typography, TextField, InputAdornment, Menu } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useDispatch, useSelector } from 'react-redux';
import { timeAgo, formatDate, formatTimeUTCandIST } from '../../utils/dateTime';
import { demoteUser, fetchUsersList, verifyIosUser } from '../../api/user';
import { useNotification } from '../../hooks/useNotification';
import useSocket from '../../hooks/useSocket';
import SuspendCard from './SuspendCard';
import Tooltip from '@mui/material/Tooltip';
import UserProfileMainPage from '../user-profile-main/UserProfileMainPage';
import UserInitiateModal from '../user-Initiate-modal/UserInitiateModal';
import HideFromSearchModal from './HideFromSearchModal';
import ShadowHideModal from './ShadowHideModal';
import { setSearchTermAction } from '../../containers/app-container/reducer/filterSlice';
import { initColumns, updateMultipleColumns, resetColumns } from '../../containers/app-container/reducer/visibleColumnsSlice';
import ErrorBoundary from '../common/ErrorBoundary';
import { downloadCsv } from '../../utils/fileUtils';
import { ExportIcon, ManageColumnIcon } from '../../icons';
import { canManageUsers } from '../../config/rolePermissions';
import { statusLabel } from '../../utils/memberStatus';
import { formatDevice } from '../../utils/CommonUtils';
import { cellSx, headSx, stickySx, stickyHeadSx, outlineBtnSx, paginationSx, STATUS_STYLE_MAP, DEFAULT_STATUS_STYLE, Muted, Pill, CountPill } from '../common/table/tableKit';
import ColumnsDrawer from '../common/table/ColumnsDrawer';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 600,
  width: '95%',
  margin: '0 auto',
  bgcolor: 'background.paper',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
  maxHeight: '80vh', // Adjust the height for scrolling
  overflow: 'auto', // Make content scrollable
};
const styleUser = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 1080,
  width: '95%',
  margin: '0 auto',
  bgcolor: 'background.paper',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
  maxHeight: '80vh', // Adjust the height for scrolling
  overflow: 'auto', // Make content scrollable
};
export const style2 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 1300,
  width: '95%',
  margin: '0 auto',
  bgcolor: 'background.paper',
  borderRadius: '20px',
  boxShadow: 24,
  p: '0 30px 30px 30px',
  maxHeight: '80vh', // Adjust the height for scrolling
  overflow: 'auto', // Make content scrollable
};

// One list drives the header, the Columns drawer and the cells. Keys are the saved-preference keys
// (visibleColumns.pages.users); `member` folds in the old Email/Age/Gender/Username/First Name columns.
const COLUMNS = [
  { key: 'member', label: 'Member', required: true },
  { key: 'location', label: 'Location' },
  { key: 'accountStatus', label: 'Status', align: 'center' },
  { key: 'hideReason', label: 'Reason' },
  { key: 'subscription', label: 'Plan', align: 'center' },
  { key: 'verification', label: 'Verification', align: 'center' },
  { key: 'preferences.gender', label: 'Looking for', align: 'center' },
  { key: 'registrationDate', label: 'Joined' },
  { key: 'profileCompletion', label: 'Profile' },
  { key: 'step', label: 'Step' },
  { key: 'appInstalled', label: 'Platform' },
  { key: 'lastLogin', label: 'Last seen' },
  { key: 'session', label: 'Sessions', align: 'center' },
  { key: 'duration', label: 'Time spent', align: 'center' },
  { key: 'profileView', label: 'Views', align: 'center' },
  { key: 'interested', label: 'Interested', align: 'center' },
  { key: 'conversation', label: 'Chats', align: 'center' },
  { key: 'flags', label: 'Reports', align: 'center' },
  { key: 'blockedByUsers', label: 'Blocked by', align: 'center' },
  { key: 'action', label: 'Actions', align: 'center', required: true },
];
const visibleColumnKey = COLUMNS.map((c) => c.key);
// CSV columns the Member cell stands for; exported whenever Member is shown.
const MEMBER_EXPORT_KEYS = ['email', 'age', 'gender', 'userName', 'firstName'];

const PLAN_STYLE = {
  Gold: { bg: '#FFF6D6', color: '#8A6D00' },
  Luxury: { bg: '#F6EDD9', color: '#7A4E00' },
  Subscribed: { bg: '#E6F4EA', color: '#008E40' },
  Expired: { bg: '#FDECEA', color: '#B3261E' },
};
const VERIFY_STYLE = {
  Verified: { bg: '#E6F4EA', color: '#008E40' },
  Active: { bg: '#E6F4EA', color: '#008E40' },
  Pending: { bg: '#FFF4E5', color: '#B26A00' },
};
const REJECT_STYLE = { bg: '#FDECEA', color: '#D93025' };
const menuItemSx = { fontSize: 13, color: '#3C4043', py: 1, px: 2 };
const iconBtnSx = { border: '1px solid #E6E6E6', borderRadius: '8px', color: '#5F6368', '&:hover': { color: '#BE1F1F', borderColor: '#BE1F1F' } };
const PAGE_SIZES = [25, 50, 100];
// `showProfileColumn` adds a leading clickable profile-picture column that opens
// the user's profile (same modal as the Action ▸ View item). It's opt-in and OFF
// by default; the Channel-Attribution members list and User Management pass it.
// Bot Management gets the same column from UserBotList, which renders it always.
const UserList = ({ type = 'user', showProfileColumn = false }) => {
  const searchTermFromStore = useSelector((state) => state.filter.searchTerm);
  // Read-only roles (e.g. Moderator) only see "View" in the Actions menu — every
  // write action below is gated on this. Backend roleAccessMiddleware enforces it too.
  const canManage = useSelector((state) => canManageUsers(state.auth.role));
  // A row can also be a DELETED profile: the attribution Sign Ups list unions the
  // delete-log in (getUsers' $unionWith) so its total equals the tree's Sign Ups
  // count. Those accounts no longer exist in `users`, so every write action would
  // target nothing — only "View" (the archived profile) applies to them.
  const canActOn = (user) => canManage && !user?.isDeletedAccount;
  const dispatch = useDispatch()
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const { emitVerificationStatus } = useSocket();
  const [approvingUserId, setApprovingUserId] = useState(null);
  const [demotingUserId, setDemotingUserId] = useState(null);
  const abortControllerRef = useRef(null);
  const debounceTimeoutRef = useRef(null);
  // Tracks the filter/search/limit signature the totals were last set for, so
  // paging through the same result set doesn't refresh totalPages (the backend
  // recomputes totalUsersCount live, which would otherwise jiggle it by ±1).
  const lastTotalsKeyRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState(null);
  const [open, setOpen] = useState(false);
  const [openSuspend, setOpenSuspend] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [userData, setUserData] = useState([]);
  const [openInitiate, setOpenInitiate] = useState(false);
  const [openHideFromSearch, setOpenHideFromSearch] = useState(false);
  const [openShadowHide, setOpenShadowHide] = useState(false);
  const visibleColumns = useSelector(state => state.visibleColumns.pages.users || {});
  const fullFilter = useSelector((state) => state.filter);
  const [currentPage, setCurrentPage] = useState(1);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = fullFilter;
    setCurrentPage(1)  //reset to pg 1 when filter change
    return rest;
  }, [JSON.stringify(fullFilter)]);


  const { filter } = useSelector((state) => state);
  const [selectedUser, setSelectedUser] = useState(false);
  const [pageLimit, setPageLimit] = useState(25);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);

  // useEffect(() => {
  //   setTotalPages(Math.ceil(totalUsers / itemsPerPage));
  // }, [totalUsers]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const data = await fetchUsersList({
        filter: { ...filter, requestType: "user_management" },
        setUserData,
        page: currentPage,
        limit: pageLimit,
        skip: 0,
        isBot: false,
        searchTerm: filterWithoutUTM?.searchTerm
      });
      // Refresh the totals only when the result set (filters/search/limit)
      // changes — not on every page click — so the page count stays stable
      // while browsing an actively changing window.
      const totalsKey = `${JSON.stringify(filterWithoutUTM)}|${pageLimit}`;
      if (lastTotalsKeyRef.current !== totalsKey) {
        lastTotalsKeyRef.current = totalsKey;
        setTotalUsers(data.totalUsersCount);
        setTotalPages(data.totalPages);
      }
    } catch (err) {
      console.error('Error while loading user data', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filterWithoutUTM), currentPage, pageLimit]);
  const handleOpen = (user) => {
    setSelectedUser(user);
    setOpen(true);
  };

  const handleOpenSuspend = (user) => {
    setSelectedUser(user);
    setOpenSuspend(true);
  };

  const handleOpenProfile = (user) => {
    setSelectedUser(user);
    setOpenProfile(true);
  };

  // Row-level "click anywhere to view profile" — only active when the profile
  // column is enabled (attribution members list). Clicks on interactive controls
  // (Action menu, Activity Logs, links/buttons/inputs, or anything tagged
  // data-no-row-open) are ignored so their own behaviour still works.
  const handleRowOpenProfile = (e, user) => {
    // MUI's Select opens on mousedown and portals its menu + full-screen
    // backdrop to <body>; the follow-up click then lands on that overlay and
    // bubbles here through the React tree with a target that isn't inside the
    // row — so anything outside the row's own DOM must never open the profile.
    if (!e.currentTarget.contains(e.target)) return;
    if (e.target.closest('a, button, input, select, [role="button"], .MuiFormControl-root, [data-no-row-open]')) return;
    handleOpenProfile(user);
  };

  const handleOpenHideFromSearch = (user) => {
    setSelectedUser(user);
    setOpenHideFromSearch(true);
  };
  const handleOpenShadowHide = (user) => {
    setSelectedUser(user);
    setOpenShadowHide(true);
  };
  const handleCloseShadowHide = () => setOpenShadowHide(false);
  const handleMoveToBottom = async (user) => {
    if (!user?._id || demotingUserId) return;
    try {
      setDemotingUserId(user._id);
      const result = await demoteUser({ userId: user._id });
      if (result?.success) {
        showSuccessNotification(
          user?.demotedByAdmin
            ? 'Profile position restored'
            : 'Profile moved to the bottom of search'
        );
        fetchData();
      } else {
        showErrorNotification(result?.message || 'Could not update profile position');
      }
    } catch (err) {
      showErrorNotification('Failed to update profile position. Please try again.');
    } finally {
      setDemotingUserId(null);
    }
  };

  const handleVerificationAction = async (user, action) => {
    if (!user?._id || approvingUserId) return;
    if (action !== 'approve' && action !== 'reject') return;
    try {
      setApprovingUserId(user._id);
      const result = await verifyIosUser(user._id, action);
      if (result?.success) {
        // Notify the iOS user in real time about their verification status
        emitVerificationStatus({
          userId: user._id,
          status: action === 'approve' ? 'approved' : 'rejected',
          isVerified: action === 'approve',
        });
        showSuccessNotification(
          action === 'approve'
            ? 'Verification approved — user can access the API workspace'
            : 'Verification rejected'
        );
        fetchData();
      } else {
        showErrorNotification(
          result?.message ||
            (action === 'approve'
              ? 'Could not approve verification'
              : 'Could not reject verification')
        );
      }
    } catch (err) {
      showErrorNotification(
        action === 'approve'
          ? 'Failed to approve verification. Please try again.'
          : 'Failed to reject verification. Please try again.'
      );
    } finally {
      setApprovingUserId(null);
    }
  };

  const handleClose = () => setOpen(false);
  const handleCloseSuspend = () => setOpenSuspend(false);
  const handleCloseProfile = () => setOpenProfile(false);
  const handleCloseHideFromSearch = () => setOpenHideFromSearch(false);
  const filteredData = userData
  // .filter((user) =>
  //   Object.values(user).some(
  //     (value) =>
  //       typeof value === 'string' &&
  //       value.toLowerCase().includes(searchTerm.toLowerCase())
  //   )
  // );

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    dispatch(
      initColumns({
        pageKey: "users",
        columns: visibleColumnKey
      })
    );
  }, []);

  // useEffect(() => {
  //   if (searchTerm === undefined || searchTerm === null) return;
  //   dispatch(setSearchTermAction({ searchTerm }));
  //   if (debounceTimeoutRef.current) {
  //     clearTimeout(debounceTimeoutRef.current);
  //   }

  //   debounceTimeoutRef.current = setTimeout(() => {
  //     if (abortControllerRef.current) {
  //       abortControllerRef.current.abort();
  //     }
  //     const controller = new AbortController();
  //     abortControllerRef.current = controller;

  //     fetchData(controller.signal)
  //       .catch((err) => {
  //         if (err.name !== "AbortError") {
  //           console.error("Search error:", err);
  //         }
  //       });
  //   }, 300);

  //   return () => {
  //     if (debounceTimeoutRef.current) {
  //       clearTimeout(debounceTimeoutRef.current);
  //     }
  //     if (abortControllerRef.current) {
  //       abortControllerRef.current.abort();
  //     }
  //   };
  // }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === undefined || searchTerm === null) return

    clearTimeout(debounceTimeoutRef.current);

    debounceTimeoutRef.current = setTimeout(() => {
      dispatch(setSearchTermAction({ searchTerm }))
    }, 300);

    return () => {
      clearTimeout(debounceTimeoutRef.current);
    };
  }, [searchTerm]);

  useEffect(() => {
    if (searchTermFromStore == null && searchTerm) setSearchTerm(null);
  }, [searchTermFromStore])


  // The server decides the status (getUsers `statusBucket`); this only names and colours it.
  const getUserStatus = (user) => {
    if (user?.isDeletedAccount) return { label: statusLabel('deleted'), style: STATUS_STYLE_MAP.deleted };
    if (user?.statusBucket) {
      return { label: statusLabel(user.statusBucket), style: STATUS_STYLE_MAP[user.statusBucket] || DEFAULT_STATUS_STYLE };
    }
    return legacyUserStatus(user);
  };

  // Rollout fallback for a server that does not send statusBucket yet — remove once it does.
  const legacyUserStatus = (user) => {
    // Highest priority — mirrors the canonical state machine, where `deleted` outranks
    // every other bucket. These rows come from the delete-log overlay on the
    // attribution Sign Ups list; without this they'd fall through to the live-profile
    // rules and render as "Incomplete Profile" off a frozen dump.
    if (user.isDeletedAccount) {
      return { label: "Deleted", style: STATUS_STYLE_MAP.deleted };
    }

    if (user.suspend) {
      return { label: "Suspended", style: STATUS_STYLE_MAP.suspended };
    }

    if (user.isInvisible && user.hideByAdmin) {
      return { label: "Hidden by Admin", style: STATUS_STYLE_MAP.hidden };
    }

    if (user.shadowHiddenByAdmin) {
      return { label: "Shadow Hidden", style: STATUS_STYLE_MAP.hidden };
    }

    if (user.active === false) {
      return { label: "Deactivated", style: STATUS_STYLE_MAP.deactivated };
    }

    if (user.profileCompletion < 100) {
      return { label: "Incomplete Profile", style: STATUS_STYLE_MAP.ghost };
    }

    const notVerified =
      user.selfieVerificationStatus !== "Approved" ||
      !user.profilePicture;

    if (notVerified) {
      return { label: "Inactive", style: STATUS_STYLE_MAP.inactive };
    }

    if (user.isInvisible) {
      return { label: "Hidden", style: STATUS_STYLE_MAP.hidden };
    }

    return { label: "Active", style: STATUS_STYLE_MAP.approved };
  };

  // CSV export — columns mirror the table (and respect the visible-columns
  // selection), minus the non-data Activity Logs / Action columns.
  const exportHeaders = [
    { key: 'email', label: 'Email' },
    { key: 'age', label: 'Age' },
    { key: 'gender', label: 'Gender' },
    { key: 'preferences.gender', label: 'Gender Preference' },
    { key: 'location', label: 'Location' },
    { key: 'userName', label: 'Username' },
    { key: 'firstName', label: 'First Name' },
    { key: 'subscription', label: 'Subscription Status' },
    { key: 'registrationDate', label: 'Registration Date' },
    { key: 'profileCompletion', label: 'Profile Completion' },
    { key: 'step', label: 'Step' },
    { key: 'session', label: 'Session' },
    { key: 'interested', label: 'Interested' },
    { key: 'profileView', label: 'Profile View' },
    { key: 'conversation', label: 'Conversation' },
    { key: 'duration', label: 'Duration' },
    { key: 'appInstalled', label: 'App Installed' },
    { key: 'verification', label: 'Verification' },
    { key: 'accountStatus', label: 'Account Status' },
    { key: 'hideReason', label: 'Reason' },
    { key: 'lastLogin', label: 'Last Login' },
    { key: 'flags', label: 'Flag/Report by Users' },
    { key: 'blockedByUsers', label: 'Blocked by Users' },
  ];

  // Canonical onboarding step for the "Step" column — the furthest step the user
  // reached / dropped at, shown as "<number> · <name>" using the SAME taxonomy as the
  // Onboarding Drop-off funnel. The server (getUsers) derives ghostStep/ghostStepLabel
  // from helpers/ghostFunnel.js (single source of truth). Falls back to the raw step
  // number if a stale backend hasn't shipped the canonical fields yet.
  const formatGhostStep = (user) => {
    if (user?.ghostStep) {
      return user?.ghostStepLabel ? `${user.ghostStep} · ${user.ghostStepLabel}` : `${user.ghostStep}`;
    }
    // Stale-backend fallback only. Prefer stepName — the screen the member last saved.
    // Since the 2026-08-25 reorder the raw `step` is the highest MARKER ever sent, not a
    // position in the flow (it reads 17 for everyone past the Work Field screen), so it is
    // the weaker of the two and must not be preferred over a name.
    return user?.stepName || (user?.step ?? '');
  };

  const getSubscriptionLabel = (user) => {
    if (user?.subscriptionPlan === 'Gold') return 'Gold';
    if (user?.subscriptionPlan === 'Luxury') return 'Luxury';
    if (user?.isSubscribed) return 'Subscribed';
    // `everSubscribed` is sent ONLY by the Channel Attribution "Subscribed" drill-through,
    // where every row is a paying member by construction. Without this, a member who paid
    // and then lapsed reads "Free" under a heading that says Subscribed — the list would
    // deny the payment that put the row there. Absent on every other screen, which keeps
    // the plain Free/Subscribed split unchanged.
    return user?.everSubscribed ? 'Expired' : 'Free';
  };

  const getVerificationLabel = (user) => {
    if (user?.isIosUser) {
      return user?.isVerified === true ? 'Active' : user?.isVerified === false ? 'Rejected' : 'Pending';
    }
    return user?.selfieVerificationStatus === 'Approved'
      ? 'Verified'
      : user?.selfieVerificationStatus === 'Unverified'
        ? 'Pending'
        : 'Mismatch';
  };

  const mapUserToCsvRow = (user) => ({
    email: user?.email ?? '',
    age: user?.age ?? '',
    gender: user?.gender ?? '',
    'preferences.gender': user?.preferences?.gender?.[0] ?? '',
    location: [user?.city, user?.state, user?.country].filter(Boolean).join(', '),
    userName: user?.userName ?? '',
    firstName: user?.firstName ?? '',
    subscription: getSubscriptionLabel(user),
    registrationDate: user?.createdAt ? `${formatDate(user.createdAt)} ${formatTimeUTCandIST(user.createdAt)}` : '',
    profileCompletion: user?.profileCompletion === 100 && !user?.profilePicture ? 95 : (user?.profileCompletion ?? ''),
    step: formatGhostStep(user),
    session: user?.sessionCount ?? 0,
    interested: user?.interestedCount ?? 0,
    profileView: user?.viewCount ?? 0,
    conversation: user?.conversationCount ?? 0,
    duration: user?.totalDuration ?? '',
    appInstalled: user?.appInstalled ? 'Yes' : 'No',
    verification: getVerificationLabel(user),
    accountStatus: getUserStatus(user)?.label ?? '',
    hideReason: user?.suspend ? (user?.suspendReason ?? '') : (user?.hideReason ?? ''),
    lastLogin: [user?.isOnLine ? 'Online' : (user?.lastLogin ? timeAgo(user.lastLogin) : '0'), user?.appInstalled && formatDevice(user?.deviceInfo)].filter(Boolean).join(' · '),
    flags: user?.reportCount ?? 0,
    blockedByUsers: user?.blockCount ?? 0,
  });

  const handleExport = async () => {
    const headers = exportHeaders.filter((header) =>
      MEMBER_EXPORT_KEYS.includes(header.key) ? isShown('member') : isShown(header.key));
    if (!headers.length) {
      showErrorNotification('Select at least one column to export');
      return;
    }
    try {
      setExporting(true);
      // Fetch the entire filtered set (not just the current page). A no-op
      // setUserData keeps the paginated table untouched; rows come from the
      // returned payload.
      const exportLimit = totalUsers && totalUsers > 0 ? totalUsers : 100000;
      const response = await fetchUsersList({
        filter: { ...filter, requestType: 'user_management' },
        setUserData: () => { },
        page: 1,
        limit: exportLimit,
        skip: 0,
        isBot: false,
        searchTerm: filterWithoutUTM?.searchTerm,
      });
      const rows = (response?.users || []).map(mapUserToCsvRow);
      downloadCsv({ fileName: 'user-management.csv', headers, rows });
      showSuccessNotification(`Exported ${rows.length} user${rows.length === 1 ? '' : 's'}`);
    } catch (err) {
      console.error('Error while exporting users', err);
      showErrorNotification(err?.response?.data?.message || err?.message || 'Failed to export users');
    } finally {
      setExporting(false);
    }
  };



  // Unset keys count as shown, so a column added later appears until the admin hides it.
  const isShown = (key) => COLUMNS.find((c) => c.key === key)?.required || visibleColumns[key] !== false;
  const shownColumns = COLUMNS.filter((c) => isShown(c.key));
  const resolvedVisible = Object.fromEntries(COLUMNS.map((c) => [c.key, isShown(c.key)]));
  const [openColumnsDrawer, setOpenColumnsDrawer] = useState(false);
  const [menu, setMenu] = useState(null); // { anchor, user }
  const closeMenu = () => setMenu(null);
  const act = (fn) => () => { closeMenu(); fn(); };
  const firstShown = (currentPage - 1) * pageLimit + 1;

  const renderCell = (col, user) => {
    const td = (children, sx = {}) => <Box component="td" key={col.key} sx={{ ...cellSx, textAlign: col.align || 'left', ...sx }}>{children}</Box>;
    switch (col.key) {
      case 'member': {
        const name = user.firstName || user.userName || 'Unnamed';
        return td(
          <Box display="flex" alignItems="center" gap={1.25}>
            {/* Sized box: the theme's img { max-width: 100% } drops a bare img from the column's width. */}
            <Box sx={{ position: 'relative', flexShrink: 0, width: 38, height: 38 }}>
              <Box
                component="img"
                src={user.profilePicture || '/assets/images/admin-panel/avatar-placeholder.svg'}
                onError={(e) => { e.currentTarget.src = '/assets/images/admin-panel/avatar-placeholder.svg'; }}
                alt=""
                onClick={(e) => { e.stopPropagation(); handleOpenProfile(user); }}
                sx={{ width: 38, height: 38, borderRadius: '50%', objectFit: 'cover', cursor: 'pointer', display: 'block' }}
              />
              {user.isOnLine && (
                <Box sx={{ position: 'absolute', right: 0, bottom: 0, width: 10, height: 10, borderRadius: '50%', bgcolor: '#1E8E3E', border: '2px solid #fff' }} />
              )}
            </Box>
            <Box>
              <Typography
                onClick={(e) => { e.stopPropagation(); handleOpenProfile(user); }}
                sx={{ fontSize: 14, fontWeight: 600, color: '#1F1F1F', textTransform: 'capitalize', cursor: 'pointer', whiteSpace: 'nowrap', '&:hover': { color: '#2E80DB' } }}
              >
                {name}
                {(user.age || user.gender) && (
                  <Box component="span" sx={{ ml: 0.75, fontSize: 12, fontWeight: 400, color: '#9AA0A6', textTransform: 'none' }}>
                    · {[user.age, user.gender].filter(Boolean).join(' · ')}
                  </Box>
                )}
              </Typography>
              <Typography sx={{ fontSize: 12, color: '#6A7282', whiteSpace: 'nowrap' }}>
                {user.userName && user.userName !== name ? `@${user.userName} · ` : ''}{user.email || '—'}
              </Typography>
            </Box>
          </Box>,
          // width 1% + nowrap: the column takes exactly its widest name/email, never overlapping Location.
          { ...stickySx, width: '1%', whiteSpace: 'nowrap' }
        );
      }
      case 'location': {
        const first = user.city || user.state;
        return td(first || user.country ? (
          <>
            <Typography sx={{ fontSize: 13, color: '#3C4043', whiteSpace: 'nowrap' }}>{first || user.country}</Typography>
            {first && user.country && <Typography sx={{ fontSize: 12, color: '#9AA0A6', whiteSpace: 'nowrap' }}>{user.country}</Typography>}
          </>
        ) : <Muted />, { minWidth: 120 });
      }
      case 'accountStatus': {
        const status = getUserStatus(user);
        return td(<Pill bg={status.style?.bg} color={status.style?.color}>{status.label}</Pill>);
      }
      case 'hideReason': {
        const reason = user?.suspend ? user?.suspendReason : user?.hideReason;
        return td(reason ? (
          <Tooltip title={reason} placement="top-start">
            <Typography sx={{ fontSize: 12, color: '#B3261E', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{reason}</Typography>
          </Tooltip>
        ) : <Muted />);
      }
      case 'subscription': {
        const plan = getSubscriptionLabel(user);
        return td(<Pill {...PLAN_STYLE[plan]}>{plan}</Pill>);
      }
      case 'verification': {
        const label = getVerificationLabel(user);
        const tone = VERIFY_STYLE[label] || REJECT_STYLE;
        return td(
          <Pill bg={tone.bg} color={tone.color}>
            {(label === 'Verified' || label === 'Active') && <VerifiedIcon sx={{ fontSize: 13 }} />}
            {label}
          </Pill>
        );
      }
      case 'preferences.gender':
        return td(user.preferences?.gender?.[0] || <Muted />);
      case 'registrationDate':
        return td(user.createdAt ? (
          <>
            <Typography sx={{ fontSize: 13, color: '#3C4043', whiteSpace: 'nowrap' }}>{formatDate(user.createdAt)}</Typography>
            <Typography sx={{ fontSize: 12, color: '#9AA0A6', whiteSpace: 'nowrap' }}>{formatTimeUTCandIST(user.createdAt)}</Typography>
          </>
        ) : <Muted />);
      case 'profileCompletion': {
        const pct = user.profileCompletion === 100 && !user?.profilePicture ? 95 : (user?.profileCompletion ?? 0);
        const tone = pct >= 100 ? '#1E8E3E' : pct >= 60 ? '#C77700' : '#D93025';
        return td(
          <Box sx={{ minWidth: 90 }}>
            <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#3C4043' }}>{pct}%</Typography>
            <Box sx={{ height: 5, borderRadius: 3, bgcolor: '#EFEFEF', mt: 0.5 }}>
              <Box sx={{ height: '100%', width: `${Math.min(100, pct)}%`, borderRadius: 3, bgcolor: tone }} />
            </Box>
          </Box>
        );
      }
      case 'step':
        return td(formatGhostStep(user) || <Muted />, { whiteSpace: 'nowrap' });
      case 'appInstalled': {
        const Icon = user.appInstalled ? SmartphoneOutlinedIcon : ComputerOutlinedIcon;
        const device = user.appInstalled && formatDevice(user.deviceInfo);
        return td(
          <Tooltip title={device || ''} placement="top">
            <Box display="inline-flex" alignItems="center" gap={0.75}
              sx={{ px: 1, py: '3px', border: '1px solid #EAEAEA', borderRadius: '6px', bgcolor: '#FAFAFA', whiteSpace: 'nowrap', fontSize: 13 }}>
              <Icon sx={{ fontSize: 15, color: '#5F6368' }} />
              {user.appInstalled ? 'App' : 'Web'}
              {user.appInstalled && user.deviceInfo?.brand && (
                <Box component="span" sx={{ color: '#9AA0A6', textTransform: 'capitalize' }}>· {user.deviceInfo.brand}</Box>
              )}
            </Box>
          </Tooltip>
        );
      }
      case 'lastLogin':
        return td(user.isOnLine ? (
          <Box display="inline-flex" alignItems="center" gap={0.75} sx={{ color: '#1E8E3E', fontWeight: 600, whiteSpace: 'nowrap' }}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#1E8E3E' }} /> Online
          </Box>
        ) : user.lastLogin ? (
          <Tooltip title={`${formatDate(user.lastLogin)} ${formatTimeUTCandIST(user.lastLogin)}`} placement="top">
            <span style={{ whiteSpace: 'nowrap' }}>{timeAgo(user.lastLogin)}</span>
          </Tooltip>
        ) : <Muted />);
      case 'session':
        return td(<CountPill value={user.sessionCount || 0} />);
      case 'duration':
        return td(user.totalDuration || <Muted />, { whiteSpace: 'nowrap' });
      case 'profileView':
        return td(<CountPill value={user.viewCount || 0} />);
      case 'interested':
        return td(
          <Box display="inline-flex" alignItems="center" gap={0.5}>
            {user.showFavorite && <FavoriteIcon sx={{ fontSize: 14, color: '#D93025' }} />}
            <CountPill value={user.interestedCount || 0} />
          </Box>
        );
      case 'conversation':
        return td(<CountPill value={user.conversationCount || 0} />);
      case 'flags':
        return td(<CountPill value={user.reportCount || 0} tone="#D93025" />);
      case 'blockedByUsers':
        return td(<CountPill value={user.blockCount || 0} tone="#C77700" />);
      case 'action':
        return td(
          <Box display="inline-flex" gap={0.75} data-no-row-open>
            <Tooltip title="Activity logs">
              <IconButton size="small" onClick={() => handleOpen(user)} sx={iconBtnSx}><TimelineOutlinedIcon sx={{ fontSize: 18 }} /></IconButton>
            </Tooltip>
            <Tooltip title="View profile">
              <IconButton size="small" onClick={() => handleOpenProfile(user)} sx={iconBtnSx}><PersonOutlineIcon sx={{ fontSize: 18 }} /></IconButton>
            </Tooltip>
            {canActOn(user) && (
              <Tooltip title="More actions">
                <IconButton size="small" onClick={(e) => setMenu({ anchor: e.currentTarget, user })} sx={iconBtnSx}><MoreVertIcon sx={{ fontSize: 18 }} /></IconButton>
              </Tooltip>
            )}
          </Box>,
          { whiteSpace: 'nowrap' }
        );
      default:
        return td(null);
    }
  };

  const menuUser = menu?.user;

  return (
    <>
      {/* TOOLBAR */}
      <Box display="flex" justifyContent="space-between" alignItems="flex-end" flexWrap="wrap" gap={2} mb={2}>
        <Box>
          <Typography fontWeight={600} sx={{ fontSize: '20px', color: '#000' }}>{filter?.statsTitle ?? 'Members'}</Typography>
          <Typography sx={{ fontSize: '14px', color: '#6A7282', pt: 0.5 }}>
            {loading ? 'Loading…' : `${(totalUsers || 0).toLocaleString()} member${totalUsers === 1 ? '' : 's'} match the current filters.`}
          </Typography>
        </Box>
        <Box display="flex" gap={1.5}>
          <TextField
            size="small"
            placeholder="Search name, email, city"
            value={searchTerm || ''}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start"><SearchIcon sx={{ fontSize: 18, color: '#9AA0A6' }} /></InputAdornment>,
              endAdornment: searchTerm ? (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchTerm('')}><CloseIcon sx={{ fontSize: 16 }} /></IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              width: 260,
              '& .MuiOutlinedInput-root': {
                height: 36, fontSize: '13px', borderRadius: '8px', bgcolor: '#fff',
                '& fieldset': { borderColor: 'rgb(0, 0, 0, 0.1)' },
                '&:hover fieldset': { borderColor: '#BE1F1F' },
                '&.Mui-focused fieldset': { borderColor: '#BE1F1F', borderWidth: 1.5 }
              },
            }}
          />
          <Button onClick={() => setOpenColumnsDrawer(true)} sx={outlineBtnSx}>
            <ManageColumnIcon /> Columns
          </Button>
          <Button variant="outlined" onClick={handleExport} disabled={exporting || loading} sx={outlineBtnSx}>
            <ExportIcon /> {exporting ? 'Exporting…' : 'Export'}
          </Button>
        </Box>
      </Box>

      {/* TABLE */}
      <Paper sx={{ boxShadow: '0 1px 2px rgba(16,24,40,0.04)', border: '1px solid #ECECEC', borderRadius: '12px', overflow: 'hidden' }}>
        <Box sx={{
          overflow: 'auto',
          maxHeight: 'calc(100vh - 250px)',
          '&::-webkit-scrollbar': { height: 8, width: 8 },
          '&::-webkit-scrollbar-thumb': { backgroundColor: '#D0D0D0', borderRadius: 4 },
        }}>
          <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0 }}>
            <thead>
              <tr>
                <Box component="th" sx={{ ...headSx, width: 40 }}>#</Box>
                {shownColumns.map((col) => (
                  <Box component="th" key={col.key} sx={{ ...headSx, ...(col.key === 'member' && stickyHeadSx), textAlign: col.align || 'left' }}>
                    {col.label}
                  </Box>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 10 }).map((_, i) => (
                  <tr key={i}>
                    {[{ key: '#' }, ...shownColumns].map((col) => (
                      <Box component="td" key={col.key} sx={cellSx}>
                        <Skeleton variant="text" height={20} width={col.key === 'member' ? 180 : '70%'} />
                      </Box>
                    ))}
                  </tr>
                ))
              ) : filteredData.length === 0 ? (
                <tr>
                  <td colSpan={shownColumns.length + 1} style={{ padding: '56px 12px', textAlign: 'center' }}>
                    <Box display="flex" flexDirection="column" alignItems="center" gap={1.5}>
                      <SearchOffIcon sx={{ fontSize: 44, color: '#BDBDBD' }} />
                      <Typography sx={{ fontSize: 16, color: '#424242', fontWeight: 600 }}>No members found</Typography>
                      <Typography sx={{ fontSize: 13, color: '#757575' }}>
                        {searchTerm ? `Nothing matches "${searchTerm}".` : 'No members match the current filters.'}
                      </Typography>
                    </Box>
                  </td>
                </tr>
              ) : (
                filteredData.map((user, index) => (
                  <Box
                    component="tr"
                    key={user._id || index}
                    onClick={showProfileColumn ? (e) => handleRowOpenProfile(e, user) : undefined}
                    sx={{ cursor: showProfileColumn ? 'pointer' : 'default', '&:hover td': { backgroundColor: '#FCFAF7' } }}
                  >
                    <Box component="td" sx={{ ...cellSx, color: '#9AA0A6' }}>{firstShown + index}</Box>
                    {shownColumns.map((col) => renderCell(col, user))}
                  </Box>
                ))
              )}
            </tbody>
          </table>
        </Box>

        {/* FOOTER */}
        <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5}
          sx={{ px: 2, py: 1.5, borderTop: '1px solid #F0F0F0', bgcolor: '#FCFCFC' }}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography sx={{ fontSize: 13, color: '#6A7282' }}>
              {loading ? 'Loading…' : !totalUsers ? '0 members' : (
                <>Showing <strong>{firstShown}–{firstShown + filteredData.length - 1}</strong> of <strong>{totalUsers.toLocaleString()}</strong></>
              )}
            </Typography>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography sx={{ fontSize: 13, color: '#6A7282' }}>Rows</Typography>
              <Select
                size="small"
                value={pageLimit}
                onChange={(e) => { setPageLimit(e.target.value); setCurrentPage(1); }}
                sx={{ height: 30, fontSize: 13, borderRadius: '8px', bgcolor: '#fff' }}
              >
                {PAGE_SIZES.map((n) => <MenuItem key={n} value={n} sx={{ fontSize: 13 }}>{n}</MenuItem>)}
              </Select>
            </Box>
          </Box>
          {totalPages > 1 && (
            <Pagination count={totalPages} page={currentPage} size="small" shape="rounded" onChange={handlePageChange} sx={paginationSx} />
          )}
        </Box>
      </Paper>

      <ColumnsDrawer
        open={openColumnsDrawer}
        onClose={() => setOpenColumnsDrawer(false)}
        columns={COLUMNS}
        visible={resolvedVisible}
        onApply={(updates) => dispatch(updateMultipleColumns({ pageKey: 'users', updates }))}
        onReset={() => dispatch(resetColumns({ pageKey: 'users' }))}
      />

      {/* MORE ACTIONS */}
      <Menu
        anchorEl={menu?.anchor}
        open={Boolean(menu)}
        onClose={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { borderRadius: '12px', border: '1px solid #ECECEC', boxShadow: '0 8px 24px rgba(16,24,40,0.10)', minWidth: 200 } }}
      >
        {menuUser && [
          <MenuItem key="suspend" onClick={act(() => handleOpenSuspend(menuUser))} sx={{ ...menuItemSx, ...(!menuUser.suspend && { color: '#D93025' }) }}>
            {menuUser.suspend ? 'Lift Suspension' : 'Suspend'}
          </MenuItem>,
          !menuUser.isSubscribed && (menuUser.hideByAdmin || !menuUser.isInvisible) && (
            <MenuItem key="hide" onClick={act(() => handleOpenHideFromSearch(menuUser))} sx={menuItemSx}>
              {menuUser.isInvisible ? 'Show in Search' : 'Hide from Search'}
            </MenuItem>
          ),
          menuUser.gender === 'Female' && (
            <MenuItem key="shadow" onClick={act(() => handleOpenShadowHide(menuUser))} sx={menuItemSx}>
              {menuUser.shadowHiddenByAdmin ? 'Restore to Search' : 'Shadow Hide (Women)'}
            </MenuItem>
          ),
          <MenuItem key="demote" disabled={demotingUserId === menuUser._id} onClick={act(() => handleMoveToBottom(menuUser))} sx={menuItemSx}>
            {demotingUserId === menuUser._id ? 'Processing...' : menuUser.demotedByAdmin ? 'Restore Position' : 'Move to Bottom'}
          </MenuItem>,
          <MenuItem key="message" onClick={act(() => { setSelectedUser(menuUser); setOpenInitiate(true); })} sx={menuItemSx}>
            Send Message
          </MenuItem>,
          menuUser.isIosUser && menuUser.isVerified === null && (
            <MenuItem key="approve" disabled={approvingUserId === menuUser._id} onClick={act(() => handleVerificationAction(menuUser, 'approve'))} sx={menuItemSx}>
              {approvingUserId === menuUser._id ? 'Processing...' : 'Approve Verification'}
            </MenuItem>
          ),
          menuUser.isIosUser && menuUser.isVerified === null && (
            <MenuItem key="reject" disabled={approvingUserId === menuUser._id} onClick={act(() => handleVerificationAction(menuUser, 'reject'))} sx={menuItemSx}>
              {approvingUserId === menuUser._id ? 'Processing...' : 'Reject Verification'}
            </MenuItem>
          ),
        ].filter(Boolean)}
      </Menu>

      <Modal
        open={openSuspend}
        onClose={handleCloseSuspend}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <IconButton
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
            }}
            onClick={handleCloseSuspend}
          >
            <CloseIcon />
          </IconButton>
          <SuspendCard
            userId={selectedUser?._id}
            suspend={selectedUser?.suspend}
            handleClose={handleCloseSuspend}
            fetchData={fetchData}
          />
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleUser}>
          <IconButton
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
            }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <ActivityLogs userId={selectedUser?._id} data={selectedUser} />
        </Box>
      </Modal>

      <Modal
        open={openProfile}
        onClose={handleCloseProfile}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          <Box
            sx={{
              position: 'sticky',
              top: '0px',
              backgroundColor: 'white',
              zIndex: 10,
              padding: '10px',
              borderBottom: 'none',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <IconButton
              sx={{
                position: 'absolute',
                top: 10,
                right: 0,
              }}
              onClick={handleCloseProfile}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          {/* <ProfileCard userId={selectedUser?._id} /> */}
          {/* A single malformed field must never crash the whole list — show a
              graceful message and keep the page usable. Keyed on the user so
              opening a different profile after a failure renders fresh. */}
          <ErrorBoundary
            resetKey={selectedUser?._id}
            fallback={(
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <p className="mb-2 fw-medium">This profile couldn’t be displayed.</p>
                <p className="text-secondary-light mb-3" style={{ fontSize: 13 }}>
                  Some of this user’s data is incomplete or malformed. Other profiles are unaffected.
                </p>
                <Button variant="outlined" onClick={handleCloseProfile}>Close</Button>
              </Box>
            )}
          >
            <UserProfileMainPage userId={selectedUser?._id} />
          </ErrorBoundary>
        </Box>
      </Modal>

      <HideFromSearchModal
        open={openHideFromSearch}
        onClose={handleCloseHideFromSearch}
        user={selectedUser}
        onUpdated={fetchData}
      />

      <ShadowHideModal
        open={openShadowHide}
        onClose={handleCloseShadowHide}
        user={selectedUser}
        onUpdated={fetchData}
      />

      <UserInitiateModal
        open={openInitiate}
        onClose={() => setOpenInitiate(false)}
        userId={selectedUser?._id}
      />

    </>
  );
};

export default UserList;
